import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { api } from '../services/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await api.post('/auth/request-reset', { email });
      setSuccess(true);
      setEmail('');
      // Redirecionar após 3 segundos
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || err.message || 'Erro ao enviar email de recuperação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-8">
        {/* Logo e título */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="bg-blue-100 rounded-full p-3">
              <Mail className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Esqueceu sua senha?</h1>
          <p className="text-gray-500 text-sm mt-2">
            Sem problemas! Digite seu email e enviaremos instruções para redefinir sua senha.
          </p>
        </div>

        {/* Sucesso */}
        {success && (
          <div className="bg-green-50 text-green-700 p-4 rounded-lg mb-6 text-sm border border-green-200">
            <p className="font-semibold mb-1">Email enviado com sucesso!</p>
            <p>Verifique sua caixa de entrada para as instruções de recuperação de senha.</p>
            <p className="text-xs mt-2 text-green-600">Redirecionando para login...</p>
          </div>
        )}

        {/* Erros */}
        {error && !success && (
          <div className="bg-red-50 text-red-700 p-3 rounded-lg mb-6 text-sm border border-red-200">
            {error}
          </div>
        )}

        {/* Form */}
        {!success && (
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Email */}
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                Email
              </label>
              <input
                id="email"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder-gray-400"
              />
            </div>

            {/* Botão enviar */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gray-900 text-white font-semibold py-2.5 rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 mt-6"
            >
              {loading ? 'Enviando...' : 'Enviar Instruções'}
            </button>
          </form>
        )}

        {/* Link voltar para login */}
        <Link
          to="/login"
          className="flex items-center justify-center gap-2 text-gray-600 hover:text-gray-900 font-medium mt-6 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar para Login
        </Link>
      </div>
    </div>
  );
}
